const POST_LOGIN_REDIRECT_STORAGE_KEY = 'postLoginRedirectTarget';

const AUTH_ROUTE_PREFIXES = ['/login', '/register'];

const isSafeInternalTarget = (target) => {
    if (typeof target !== 'string' || !target.startsWith('/')) return false;
    if (target.startsWith('//')) return false;
    return true;
};

export const isAuthRoute = (target) => {
    if (!isSafeInternalTarget(target)) return false;
    return AUTH_ROUTE_PREFIXES.some((prefix) => target === prefix || target.startsWith(`${prefix}?`));
};

export const buildLocationTarget = (locationLike) => {
    if (!locationLike) return '/';
    const pathname = locationLike.pathname || '/';
    const search = locationLike.search || '';
    const hash = locationLike.hash || '';
    return `${pathname}${search}${hash}`;
};

export const getCurrentLocationTarget = () => buildLocationTarget(window.location);

export const rememberPostLoginRedirectTarget = (target) => {
    if (!isSafeInternalTarget(target) || isAuthRoute(target)) return;
    sessionStorage.setItem(POST_LOGIN_REDIRECT_STORAGE_KEY, target);
};

export const rememberCurrentLocationForLogin = () => {
    rememberPostLoginRedirectTarget(getCurrentLocationTarget());
};

export const getPostLoginRedirectTarget = () => {
    const target = sessionStorage.getItem(POST_LOGIN_REDIRECT_STORAGE_KEY);
    return isSafeInternalTarget(target) && !isAuthRoute(target) ? target : null;
};

export const consumePostLoginRedirectTarget = () => {
    const target = getPostLoginRedirectTarget();
    if (target) {
        sessionStorage.removeItem(POST_LOGIN_REDIRECT_STORAGE_KEY);
    }
    return target;
};

export const clearPostLoginRedirectTarget = () => {
    sessionStorage.removeItem(POST_LOGIN_REDIRECT_STORAGE_KEY);
};
